import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import { map } from 'lodash/fp';

import PageHeading from '#components/PageHeading/PageHeading';
import type { AnySectionDefinition } from '#components/Section/Section';
import Section from '#components/Section/Section';
import onScrollAnimate from '#utils/onScrollAnimate';
import useGatePage from '#hooks/useGatePage';
import type { TableContentDefinition } from '#contentful/TableContent';

const ContentPage = ({
  data,
}: any) => {
  useEffect(() => {
    onScrollAnimate.register([
      { className: 'reveal' },
      { className: 'flair', distanceToReveal: 200 },
    ]);
  }, []);

  const { heading = null, sections = [], gateContent } = data?.page?.content ?? {};

  const { slug } = data?.page ?? {};
  const gateContentSlug = gateContent?.slug;

  useGatePage(slug, gateContentSlug);

  if (!data?.page?.content) {
    return null;
  }

  return (
    <div className="container">
      <div>
        <div>
          <PageHeading {...heading} />
        </div>
        {map((section: AnySectionDefinition | TableContentDefinition) => (
          <div key={section.id}>
            <Section section={section as AnySectionDefinition} />
          </div>
        ), sections)}
      </div>
    </div>
  );
};

export default ContentPage;

export { Head } from '#components/Head';

export const pageQuery = graphql`
  query content($slug: String!, $locale: String!) {
    page: contentfulComposePage(
      slug: {eq: $slug},
      node_locale: {eq: $locale}
    ) {
      content {
        ...ContentPageTemplate
      }
      seo {
        ...SEO
        lang: node_locale
      }
      slug
    }
    locales: allLocale(filter: {language: {eq: $locale}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
